import { Box, Grid, makeStyles, SvgIcon } from '@material-ui/core';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { FC } from 'react';
import { Calendar as CalendarIcon } from 'react-feather';
import Breadcrumbs from 'src/components/Breadcrumbs';
import PageTitle from 'src/components/PageTitle';
import { CalendarDate, ZonedDateRangePicker } from 'src/features/timezone';
import { Theme } from 'src/theme';

interface HeaderProps {
  className?: string;
  startDate: CalendarDate;
  endDate: CalendarDate;
  onDateRangeChange: (_start: CalendarDate, _end: CalendarDate) => void;
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {},
  dateRange: {
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  }
}));

const Header: FC<HeaderProps> = ({
  className,
  startDate,
  endDate,
  onDateRangeChange
}) => {
  const classes = useStyles();

  return (
    <Grid
      container
      spacing={3}
      justifyContent="space-between"
      className={clsx(classes.root, className)}
    >
      <Grid item sm={12} md={4}>
        <Breadcrumbs
          breadcrumbs={[]}
          pageTitle="Cash Transactions"
          mainHeader="Reports"
        />
        <PageTitle title="Cash Transactions" />
      </Grid>
      <Grid item sm={12} xs={12} md={8}>
        <Box mt={1}>
          <Grid container spacing={3} justifyContent="flex-end">
            <Grid item className={classes.dateRange}>
              <ZonedDateRangePicker
                buttonProps={{
                  startIcon: (
                    <SvgIcon fontSize="small">
                      <CalendarIcon />
                    </SvgIcon>
                  )
                }}
                startDate={startDate}
                endDate={endDate}
                onChange={onDateRangeChange}
              />
            </Grid>
          </Grid>
        </Box>
      </Grid>
    </Grid>
  );
};

Header.propTypes = {
  className: PropTypes.string
};

export default Header;
